import React, { createContext, useState, useContext, useMemo, ReactNode } from 'react';

interface SplitViewContextType {
  isSplitView: boolean;
  setIsSplitView: (value: boolean) => void;
}

const SplitViewContext = createContext<SplitViewContextType | undefined>(undefined);

export const SplitViewProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSplitView, setIsSplitView] = useState(false);

  const value = useMemo(() => ({ isSplitView, setIsSplitView }), [isSplitView]);

  return (
    <SplitViewContext.Provider value={value}>
      {children}
    </SplitViewContext.Provider>
  );
};

export const useSplitView = () => {
  const context = useContext(SplitViewContext);
  if (context === undefined) {
    throw new Error('useSplitView must be used within a SplitViewProvider');
  }
  return context;
};
